/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";

export interface IBookOfShadowsLayerConfig extends ILayersConfig {
    readonly BACKGROUND: ILayerConfig;
    readonly REEL_BACKGROUND: ILayerConfig;
    readonly REEL_ATTENTION: ILayerConfig;

    readonly S_GLOW_RUNE: ILayerConfig;
    readonly SYMBOLS: ILayerConfig;
    readonly SYMBOLS_TRANSFORM: ILayerConfig,
    readonly SYMBOLS_WIN_ANIM: ILayerConfig;
    readonly REELS_FRAME: ILayerConfig;
    readonly REEL_LOCK_BUTTON: ILayerConfig;
    readonly BET_LINES: ILayerConfig;
    readonly WIN_AMOUNT_BET_LINES: ILayerConfig;
    readonly NEAR_WIN: ILayerConfig;
    readonly LOGO: ILayerConfig;
    readonly INACTIVE_ROW_SHADOW: ILayerConfig;
    readonly GAME_TUTORIAL: ILayerConfig;
    readonly FREESPIN_COUNTERS: ILayerConfig;

    readonly INITIAL_WIN_AMOUNT_BET_LINES: ILayerConfig;

    readonly WIN_PRESENTATIONS: ILayerConfig,
    readonly BIG_WIN: ILayerConfig;
    readonly BIG_WIN_FOUNTAIN: ILayerConfig;
    readonly WIN_COUNT_UP: ILayerConfig;

    readonly FREE_SPIN: ILayerConfig;

    readonly ROW_SELECTOR_BUTTON_FS: ILayerConfig;

    readonly FS_FOREGROUND: ILayerConfig;

    readonly DEBUG_OVERLAY: ILayerConfig;
    readonly INTRO: ILayerConfig;
    readonly DEMO: ILayerConfig;
}

export class BookOfShadowsLayerConfig {
    public static defaultLayerScaleOptions: IDeviceDependentConfig<LayerScaleOption> = {
        desktop: {landscape: LayerScaleOption.REELS_FIT_STAGE},
        mobile: {
            landscape: LayerScaleOption.REELS_FIT_STAGE,
            portrait: LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static customOptions: CustomLayerScaleOptions = {
        frame: {x: 0, y: 0, width: 720, height: 620},
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 0.5}
            },
            mobile: {
                landscape: {x: 0.5, y: 0.5},
                portrait: {x: 0.5, y: 0.5}
            }
        },
    };

    public static reelBackground: CustomLayerScaleOptions = {
        target: {
            desktop: {
                landscape: ScaleTarget.STAGE
            },
            mobile: {
                landscape: ScaleTarget.STAGE,
                portrait: ScaleTarget.WINDOW
            }
        },
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 1}
            },
            mobile: {
                landscape: {x: 0.5, y: 1},
                portrait: {x: 0.5, y: 1}
            }
        },
        method: {
            desktop: {
                landscape: ScaleMethod.FIT
            },
            mobile: {
                landscape: ScaleMethod.FIT,
                portrait: ScaleMethod.FIT
            }
        }
    };

    public static introConfig: CustomLayerScaleOptions = {
        target: ScaleTarget.WINDOW,
        method: ScaleMethod.FIT,
        frame: {x: 0, y: 0, width: 720, height: 720},
        placement: {x: 0.5, y: 0.5}
    };

    public static BACKGROUND: ILayerConfig = {
        name: "BACKGROUND",
        customOptions: BookOfShadowsLayerConfig.introConfig
    };

    public static REEL_BACKGROUND: ILayerConfig = {
        name: "REEL_BACKGROUND",
        customOptions: BookOfShadowsLayerConfig.reelBackground
    };

    public static REEL_ATTENTION: ILayerConfig = {
        name: "REEL_ATTENTIONS",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static BET_LINES: ILayerConfig = {
        name: "BET_LINES",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static WIN_AMOUNT_BET_LINES: ILayerConfig = {
        name: "WIN_AMOUNT_BET_LINES",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static S_GLOW_RUNE: ILayerConfig = {
        name: "sGlowRune",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static SYMBOLS: ILayerConfig = {
        name: "symbols",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static SYMBOLS_TRANSFORM: ILayerConfig = {
        name: "symbolsTransform",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static SYMBOLS_WIN_ANIM: ILayerConfig = {
        name: "symbolsWinAnim",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static REELS_FRAME: ILayerConfig = {
        name: "reelsFrame",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static REEL_LOCK_BUTTON: ILayerConfig = {
        name: "reelLockButton",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static INACTIVE_ROW_SHADOW: ILayerConfig = {
        name: "inactiveRowShadow",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static FREESPIN_COUNTERS: ILayerConfig = {
        name: "FREESPIN_COUNTERS",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static GAME_TUTORIAL: ILayerConfig = {
        name: "GAME_TUTORIAL",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static WIN_PRESENTATIONS: ILayerConfig = {
        name: "WIN_PRESENTATIONS",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static WIN_COUNT_UP: ILayerConfig = {
        name: "WIN_COUNT_UP",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static FREE_SPIN: ILayerConfig = {
        name: "freeSpin",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static ROW_SELECTOR_BUTTON_FS: ILayerConfig = {
        name: "ROW_SELECTOR_BUTTON_FS",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static FS_FOREGROUND: ILayerConfig = {
        name: "FS_FOREGROUND",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static NEAR_WIN: ILayerConfig = {
        name: "NEAR_WIN",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static LOGO: ILayerConfig = {
        name: "LOGO",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static DEBUG_OVERLAY: ILayerConfig = {
        name: "DEBUG_OVERLAY",
        scaleOption: LayerScaleOption.NONE
    };

    public static INTRO: ILayerConfig = {
        name: "intro",
        customOptions: BookOfShadowsLayerConfig.introConfig
    };

    public static BIG_WIN: ILayerConfig = {
        name: "BIG_WIN",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static BIG_WIN_FOUNTAIN: ILayerConfig = {
        name: "BIG_WIN_FOUNTAIN",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static DEMO: ILayerConfig = {
        name: "DEMO",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    private static INITIAL_WIN_AMOUNT_BET_LINES: ILayerConfig = {
        name: "INITIAL_WIN_AMOUNT_BET_LINES",
        customOptions: BookOfShadowsLayerConfig.customOptions
    };

    public static getConfig(): IBookOfShadowsLayerConfig {
        return {
            BACKGROUND: BookOfShadowsLayerConfig.BACKGROUND,
            REEL_BACKGROUND: BookOfShadowsLayerConfig.REEL_BACKGROUND,
            REEL_ATTENTION: BookOfShadowsLayerConfig.REEL_ATTENTION,

            S_GLOW_RUNE: BookOfShadowsLayerConfig.S_GLOW_RUNE,
            SYMBOLS: BookOfShadowsLayerConfig.SYMBOLS,
            SYMBOLS_TRANSFORM: BookOfShadowsLayerConfig.SYMBOLS_TRANSFORM,
            SYMBOLS_WIN_ANIM: BookOfShadowsLayerConfig.SYMBOLS_WIN_ANIM,
            REELS_FRAME: BookOfShadowsLayerConfig.REELS_FRAME,
            REEL_LOCK_BUTTON: BookOfShadowsLayerConfig.REEL_LOCK_BUTTON,
            BET_LINES: BookOfShadowsLayerConfig.BET_LINES,
            WIN_AMOUNT_BET_LINES: BookOfShadowsLayerConfig.WIN_AMOUNT_BET_LINES,
            NEAR_WIN: BookOfShadowsLayerConfig.NEAR_WIN,
            LOGO: BookOfShadowsLayerConfig.LOGO,
            INACTIVE_ROW_SHADOW: BookOfShadowsLayerConfig.INACTIVE_ROW_SHADOW,
            FREESPIN_COUNTERS: BookOfShadowsLayerConfig.FREESPIN_COUNTERS,
            GAME_TUTORIAL: BookOfShadowsLayerConfig.GAME_TUTORIAL,

            INITIAL_WIN_AMOUNT_BET_LINES: BookOfShadowsLayerConfig.INITIAL_WIN_AMOUNT_BET_LINES,

            WIN_PRESENTATIONS: BookOfShadowsLayerConfig.WIN_PRESENTATIONS,
            BIG_WIN: BookOfShadowsLayerConfig.BIG_WIN,
            BIG_WIN_FOUNTAIN: BookOfShadowsLayerConfig.BIG_WIN_FOUNTAIN,
            WIN_COUNT_UP: BookOfShadowsLayerConfig.WIN_COUNT_UP,

            FREE_SPIN: BookOfShadowsLayerConfig.FREE_SPIN,

            ROW_SELECTOR_BUTTON_FS: BookOfShadowsLayerConfig.ROW_SELECTOR_BUTTON_FS,

            FS_FOREGROUND: BookOfShadowsLayerConfig.FS_FOREGROUND,

            DEBUG_OVERLAY: BookOfShadowsLayerConfig.DEBUG_OVERLAY,
            INTRO: BookOfShadowsLayerConfig.INTRO,
            DEMO: BookOfShadowsLayerConfig.DEMO
        };
    }
}